const QuoteProps = {
  'Quote Requested': { bg: 'primary', text: 'white', border: 'primary', title: 'Create Quote', icon: ''  },
  'Quote Rejected': { bg: 'danger-subtle', text: 'danger', border: 'danger-subtle', title: 'Rejected', icon: 'text-danger' },
  'Quote Available': { bg: 'primary-subtle', text: 'primary', border: 'primary-subtle', title: 'Submitted', icon: 'text-primary' },
  // Retest request statuses. This map is keyed by status and already carried the two a retest
  // shares with a quote ('Quote Requested', 'Quote Available'); a retest also ends in states a
  // quote never had. Without these, 'Cancelled' falls through to `default` and paints a green
  // tick above the word "Cancelled".
  'In Progress': { bg: 'primary-subtle', text: 'primary', border: 'primary-subtle', title: 'In Progress', icon: 'text-primary' },
  'Complete': { bg: 'success-subtle', text: 'success-emphasis', border: 'success-subtle', title: 'Complete', icon: 'text-success' },
  'Cancelled': { bg: 'danger-subtle', text: 'danger', border: 'danger-subtle', title: 'Cancelled', icon: 'text-danger' },
  default: { bg: 'success-subtle', text: 'success-emphasis', border: 'success-subtle', title: 'Accepted', icon: 'text-success' },
};

export const quoteIconTint = (status: string): string =>
  (QuoteProps[status as keyof typeof QuoteProps] ?? QuoteProps.default).icon;

export default QuoteProps;